<template>
    <div class="shop-filter-field" :class="{'shop-filter-field--compact': compact}">
        <p v-if="!compact" class="shop-filter-label">{{ formField.title }}</p>

        <div class="shop-filter-options">
            <el-radio
                v-for="option in formField.options"
                :key="option.id"
                :value="value"
                @change="handleOnChange(option.title)"
                :label="option.title"
                class="shop-filter-radio"
            >
                {{ option.title }}
            </el-radio>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Radio',
    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: '',
        }
    },

    methods: {
        handleOnChange(value) {
            this.value = value;

            this.onChangeHandler(`additional_data[${this.formField.slug}]`, this.value, true)
        }
    },

    mounted() {
        if (this.selectedFilters[`additional_data[${this.formField.slug}]`] ?? false) {
            this.value = decodeURIComponent(this.selectedFilters[`additional_data[${this.formField.slug}]`]).replaceAll('+', ' ');
        }
    }
}
</script>
